import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
const LOG = Logger.getLogger('handleSurveySubmissionResponse');
export const handleInitialInterestError = (error = {}) => {
  LOG.error('Initial Interest failed.', {
    extra: getSentryExtra(error)
  });
};